import Math from './math'
import MathHelper from "@/helpers/math";
import _ from 'underscore'
import NumberHelper from '@/helpers/number'

export default {
    getTotal(quantity, price) {
        let total = Math.multiply(quantity, price)

        return NumberHelper.round(total, -2)
    },

    getNdsValue(quantity, price, ndsRate) {
        let total = this.getTotal(quantity, price)

        let ndsMultiplier = MathHelper.multiply(ndsRate, 0.01);
        let ndsValue = MathHelper.multiply(total, ndsMultiplier);

        ndsValue = NumberHelper.round(ndsValue, -2)
        return ndsValue
    },

    getTotalWithNds(quantity, price, ndsRate) {
        let total = this.getTotal(quantity, price)
        let ndsValue = this.getNdsValue(quantity, price, ndsRate)
        let totalWithNds = total + ndsValue

        totalWithNds = NumberHelper.round(totalWithNds, -2)
        return totalWithNds
    },

    getSumTotalWithNds(totalsWithNds) {
        let sum = _.reduce(totalsWithNds, (memo, item) => {
            return memo + item
        })
        return NumberHelper.round(sum, -2)
    },

    getSumTotalNdsValue(ndsValues) {
        let sum = _.reduce(ndsValues, (memo, item) => {
            return memo + item
        })
        return NumberHelper.round(sum, -2)
    },

    getSumTotal(totals) {
        let sum = _.reduce(totals, (memo, item) => {
            return memo + item
        })
        return NumberHelper.round(sum, -2)
    },

    getDecimalWithTwoDigit(value){

        if(this.hasDecimal(value))
            return value.toFixed(2)

        return value
    },
    hasDecimal(value) {
        if(typeof (value) === 'number')
            return !!(value % 1)
    }
}